import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { AuthWebService } from '../services/authweb.service';
import { UtilityServiceService } from '../services/utility-service.service';
import { environment } from 'environments/environment';
import { isNumeric } from 'rxjs/util/isNumeric';
import { ToastrService } from 'ngx-toastr';
import { SearchCountryField, TooltipLabel, CountryISO } from 'app/shared/projects/ngx-intl-tel-input/src/public_api';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-ammenduser',
  templateUrl: './ammenduser.component.html',
  styleUrls: ['./ammenduser.component.css']
})
export class AmmenduserComponent implements OnInit {

  form;
  aUser: any = {};
  holdinguser: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;
  user = "Haddad";
  EditUser: any ={};
  isDup = false;
  selectedGroupCode: any = {};
  selectedDisplay = 3;
  params: any = {};
  loginUser: any = { UserName: 'admin', Password:'dev2019'};
	systemCode: String = null;
  AttemptCount = 0;
	OtpConfig = null;
  oldFirstName;
  oldLastName;
  oldemail='';
  oldmobile='';
  oldDialCode='+27';
  oldCommunicationType;
  ssoupdate = false;
  terms: string = null;
  public MobileNumber;
  public PhoneNumber;

  public isLoading = false;
  message = null;
  existingUsers: any;
  webservice: any;
  storageService: any;
  mobnumPattern = /^\+?(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
  numberisvalid =false;
  isadminuser = false;
 
//SADC Countries
separateDialCode = true;
SearchCountryField = SearchCountryField;
TooltipLabel = TooltipLabel;
CountryISO = CountryISO;
defaultCountry:any = CountryISO.SouthAfrica;
defaultCountryPhone:any = CountryISO.SouthAfrica;
Roles: any[] = [];
selectedRole:any;
selectedId:number;

preferredCountries: CountryISO[] = [
  CountryISO.Angola,
   CountryISO.Botswana,
   CountryISO.Comoros,
   CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
   CountryISO.Lesotho,
   CountryISO.Madagascar,
   CountryISO.Malawi,
   CountryISO.Mauritius,
   CountryISO.Mozambique,
   CountryISO.Namibia,
   CountryISO.Seychelles,
   CountryISO.Swaziland,
   CountryISO.Zambia,
   CountryISO.Zimbabwe,
  ];



  constructor(public authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,private toastService:ToastNotificationService,
     public utility: UtilityServiceService,private toastr: ToastrService) { }

  ngOnInit() {

    /* this.webservice.request('UserService', 'AuthenticatedUser', {
			userName: this.loginUser.UserName,
			password: this.loginUser.Password,
			systemCode:this.systemCode
	   }).then((data) => {

			environment.authWebApi.userData = data;
			this.storageService.setID(data.User.ID);
	
    }); */ 
    

    this.aUser = environment.authWebApi.userData.User;

    if(this.aUser.EmailAddress.includes('@cbrta.co.za')){
      this.isadminuser = true;
      document.getElementById('FirstName').setAttribute('disabled','');
      document.getElementById('LastName').setAttribute('disabled','');
      // document.getElementById('MobileNumber').setAttribute('disabled','');
      // document.getElementById('PhoneNumber').setAttribute('disabled','');
      document.getElementById('EmailAddress').setAttribute('disabled','');
      // document.getElementById('UserName').setAttribute('disabled','');
      document.getElementById('CommunicationType').setAttribute('disabled','');
      document.getElementById('role').setAttribute('disabled','');
      // document.getElementById('nterms').setAttribute('disabled','');
      // document.getElementById('SaveButton').setAttribute('disabled','');

      try {
        this.MobileNumber.elRef.nativeElement.firstChild.children[0].disabled = 'true';
        this.PhoneNumber.elRef.nativeElement.firstChild.children[0].disabled = 'true';
      } catch (e) {
        // ignore this
      }
      
    }
    
    if(this.aUser.EmailAddress === null || this.aUser.MobileNumber === null){
      this.ssoupdate = true;
    
    }

    console.log("Is this a facebook User: ", this.ssoupdate);
     
    this.initForm();

    this.authWebService.getRegisterRoles();
    this.authWebService.getRegisterRolesObservable().subscribe((result)=> {
      result.forEach(role => {

        if(role.Code == "GUEST" || role.Code == "CONS"){

          if (this.Roles.indexOf(role) < 0) {
            this.Roles.push(role);
          } 
        }

      });

    });
    
  }

  initForm() {
    console.log(this.aUser);
    this.defaultCountry = this.aUser.Iso2mobile ?? this.defaultCountry;
    this.defaultCountryPhone = this.aUser.Iso2phone?? this.defaultCountryPhone;
    this.form = new FormGroup({     
      ID: new FormControl()
      , FirstName: new FormControl(this.aUser.FirstName,Validators.compose([Validators.required, Validators.pattern('([a-zA-Z,.-]+( [a-zA-Z,.-]+)*){2,30}')]))
      , LastName: new FormControl(this.aUser.LastName, Validators.compose([Validators.required, Validators.pattern('([a-zA-Z,.-]+( [a-zA-Z,.-]+)*){2,30}')]))
       ,EmailAddress: new FormControl(this.aUser.EmailAddress, Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
      //, MobileNumber: new FormControl(this.aUser.MobileNumber,  Validators.compose([Validators.required,Validators.maxLength(15)]))
      , MobileNumber: new FormControl(this.aUser.MobileNumber,  Validators.compose([Validators.required]))
      //, PhoneNumber: new FormControl(this.aUser.PhoneNumber, Validators.compose([Validators.required,Validators.maxLength(15)]))
      , PhoneNumber: new FormControl(this.aUser.PhoneNumber, Validators.compose([Validators.required]))
      ,UserName: new FormControl(this.aUser.UserName, Validators.required)
      ,CommunicationType: new FormControl(this.aUser.CommunicationType, Validators.required)
      ,role: new FormControl('Consultant', Validators.required)
     
    });
    this.form.patchValue(this.utility.defaults);
    //console.log(this.aUser.DialCodeMobile);
  
    this.oldFirstName = this.aUser.FirstName;
    this.oldLastName = this.aUser.LastName;
    this.oldemail = this.aUser.EmailAddress;
    this.oldDialCode = this.aUser.DialCodeMobile;
    this.oldmobile = this.aUser.MobileNumber;
    this.oldCommunicationType = this.aUser.CommunicationType;

    this.authWebService.webrequest('GET','ConfigurationService', 'GetAuthUserRole', JSON.stringify({
      userId: this.aUser.Id
    })).then((data) => {
      this.selectedId = data.RoleId;
    }, (error) => {
      //console.log(error)
    });

  }
    ngOnDestroy() { 
    ///this.sub.unsubscribe();
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
        const control = form.get(key);
        const errors = (control instanceof FormGroup || control instanceof FormArray)
            ? this.getAllErrors(control)
            : control.errors;
        if (errors) {
            acc[key] = errors;
            hasError = true;
        }
        return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
}

checkMobileNumber(obj:any)
{
  //check length
  
  if (obj.MobileNumber.trim().length >= 10) 
  {
// how many spaces are in a string?
    var knt = obj.MobileNumber.trim().split(" ").length - 1;
    //console.log("what is the count");
    //console.log(knt);
    var str = new String(obj.MobileNumber.trim()); 
     for(let i =0;i<knt;i++)
     {
       str = str.replace(" ","");

     }
    
    //check char at first posn
    //console.log("number after trimming:");
    //console.log(str);
   if ( str.charAt(0) === '+') 
   {
     //remove + and check if rest can be converted to number
        if (isNumeric(str.slice(1)))
        {
          //first char is + does it follow
            if (str.slice(1).match('^27[0-9]{9}$'))
              {
                //valid number
                this.numberisvalid = true;
                obj.MobileNumber=str;

              }
              else
              {
                //not a match but starts with + perhaps a different country and is numeric
                this.numberisvalid = true;
                obj.MobileNumber=str;
              }

        }
        else
        {
          //not numeric and if you remove what chars - or ( or )
          var cnt_dash = str.split("-").length - 1;
          var cnt_open_parenthesis = str.split("(").length - 1;
          var cnt_close_parenthesis = str.split(")").length - 1;
          
          //remove dash
          for(let d=0;d<cnt_dash;d++)
          {
            str = str.replace("-","");
          }
          //remove (
          for(let e=0;e<cnt_open_parenthesis;e++)
          {
              str = str.replace("(","");
           }
          //remove )
          for(let f=0;f<cnt_close_parenthesis;f++)
          {
            str = str.replace(")","");
          }
           if (isNumeric(str))
           {
             // removed characters and we have number that starts with a +
             this.numberisvalid = true;
             obj.MobileNumber = "+"+str;
             //console.log("new number stripped and + ");
             //console.log(obj.MobileNumber)
           }
           else
           {
             this.numberisvalid = false;
           }
         
        }
     
   }
   else
   {
      //check if it is a number already
      if(isNumeric(str))
      {
         //chatAt(0) is not +
        // is it a regular number? 0892345678

          if (str.match('^0[1-9]{9}$'))
          {
            //it starts with a zero and valid number
            this.numberisvalid = true;
            obj.MobileNumber = "+27"+ str.slice(1);
            //console.log("new number");
            //console.log(obj.MobileNumber)
          }
          else
          {
            //it doesnt start with a 0 is it an international number?
            this.numberisvalid = true;
            obj.MobileNumber = "+" + str;
            //console.log("new number international");
            //console.log(obj.MobileNumber)

          }

      }
      else
      {
        //it is not a number remove the dashes - or ( or )
       
        var cnt_dash = str.split("-").length - 1;
        var cnt_open_parenthesis = str.split("(").length - 1;
        var cnt_close_parenthesis = str.split(")").length - 1;
        
        //remove dash
        for(let d=0;d<cnt_dash;d++)
        {
          str = str.replace("-","");
        }
        //remove (
        for(let e=0;e<cnt_open_parenthesis;e++)
        {
            str = str.replace("(","");
         }
        //remove )
        for(let f=0;f<cnt_close_parenthesis;f++)
        {
          str = str.replace(")","");
        }

         
        if (isNumeric(str))
        {
          // removed characters and we have number that starts with a +
          this.numberisvalid = true;
          obj.MobileNumber = "+"+str;
          //console.log("new number stripped and + ");
          //console.log(obj.MobileNumber)
        }
        else
        {
          this.numberisvalid = false;
        }

      }
    
   }
  }
  else
  {
    this.numberisvalid = false;
  }
}
ChangeCountry(event){
  //console.log(event);
  this.defaultCountry = event.iso2;
}
ChangeCountryPhone(event){
  this.defaultCountryPhone = event.iso2;

}
  onSubmit(obj:any) {
   
    if (this.isDup) { return; }
//     this.checkMobileNumber(obj);
//     if (!this.numberisvalid )
// {
//   return this.toastr.warning('Please check the Mobile Number','Amend Profile failed');
// }
  
    if (this.terms === null && this.ssoupdate == true && (this.aUser.Authenticator == 'Facebook' || this.aUser.Authenticator == 'Google') ){
      return this.toastService.error('Please click POPIA Processing Notice','Registration failed');
    }

    this.holdinguser.FirstName = obj.FirstName;
    this.holdinguser.LastName = obj.LastName;
    this.holdinguser.EmailAddress = obj.EmailAddress;
    this.holdinguser.UserName = obj.UserName;
    this.holdinguser.MobileNumber = obj.MobileNumber;
    this.holdinguser.PhoneNumber = obj.PhoneNumber;
    this.holdinguser.Iso2mobile = this.defaultCountry;
    this.holdinguser.Iso2phone = this.defaultCountryPhone;

    this.holdinguser.DialCodeMobile = obj.MobileNumber.dialCode;
    this.holdinguser.MobileNumber = obj.MobileNumber.number;
    this.holdinguser.DialCodePhone = obj.PhoneNumber.dialCode;
    this.holdinguser.PhoneNumber = obj.PhoneNumber.number;
    this.holdinguser.CommunicationType = obj.CommunicationType;
    this.holdinguser.role = obj.role;
    this.holdinguser.roleId = this.selectedId;

    this.holdinguser.DateUpdated = new Date();
    this.aUser.UserUpdated = this.aUser.Id;
    this.holdinguser.Id =  this.aUser.Id;
    this.message ="Updating a user"; 
    this.isLoading = true;

    let OtpCode = document.getElementById('OTPCode') as HTMLInputElement | null;
		let OtpMessage = document.getElementById('OtpMessage');
		OtpCode.value = "";

		if(this.oldCommunicationType== "SMS")
		{
			OtpMessage.innerHTML  = "We have sent the verification code to your mobile number.'" +this.oldDialCode + this.oldmobile +"'";
		}else
		{
			OtpMessage.innerHTML = "We have sent the verification code to your email address.'" +this.oldemail +"'" ;
		}

    document.getElementById('SaveButton').setAttribute('disabled','');

    this.aUser.SysCode = "ICBMS"
    this.authWebService.ammendUser(this.aUser, this.oldFirstName, this.oldLastName, this.oldemail, this.oldmobile);
    this.isLoading = false;
    
  }
  navigate() {
   // this.router.navigateByUrl('/login');
  }

  onDuplicates(control) {


  }

  onChanges(): void {
    this.form.get('code').valueChanges.subscribe(code => {

      if (code.length > 3) {
        this.authWebService.checkByCode(code.trim()).subscribe(result => {
          this.isDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isDup = false;

        });
      }
    });
  }



  onChangeValue() {

  }

  onSelectChange() {
    console.dir(this.selectedDisplay);
  }

  editUser() {

	/*	let validation = this.helper.validation();
		let validMobile = (this.aUser.MobileNumber || '').match(/^\+?(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/);
		let validEmail = (this.aUser.EmailAddress || '').match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		
		validation.addIf(!this.aUser, "'user' is required");
		validation.addIf(!this.aUser.ID, "'user.ID' is required");
		validation.addIf(!this.aUser.FirstName, "'FirstName' is required");
		validation.addIf(!this.aUser.LastName, "'LastName' is required");
		validation.addIf(!validMobile, "Mobile number is invalid");
		validation.addIf(!validEmail, "Email Address is invalid");*/

	//	if (validation.check()) {

  ////console.log(this.aUser)
			this.authWebService.request('UserService', 'AmmendUser', {
				user: this.aUser
			}).then((ur) => {
        //console.log(ur);
				this.router.navigate(['/login']);
			}, (error) => {
        //	this.message.danger('Failed to amend user', error.message);
        
        //console.log(error.message);
        
			});
		//}
	}

  verifyOtp()
	{
    
		const OtpCode = document.getElementById('OTPCode') as HTMLInputElement | null;
		let Otp = OtpCode.value;
		this.AttemptCount++;

    
    this.holdinguser.Otp = Otp;


		if(this.AttemptCount == 4)
		{
      this.AttemptCount = 0;
      document.getElementById('Attempts').innerHTML = "You have 3 attempts left."
			document.getElementById('secretButton').click();
      document.getElementById('SaveButton').removeAttribute('disabled');
      this.toastService.error('Exceeded OTP attempts. Please click on the Update button to generate a new OTP.','User Update');
			return true;
		}else
		{
			let count = 3 - this.AttemptCount;
		    document.getElementById('Attempts').innerHTML = "You have "+count+" attempts left."
		}

		//let Otp = OtpCode.value;
    console.log("Holding User details")
		console.log(this.holdinguser);
		this.authWebService.webrequest('POST','UserService', 'ValidateOtp', JSON.stringify(this.holdinguser)).then((ur) => {

			//if otp is valid, update the user details
      if(ur.success)
      {
        this.aUser.FirstName = this.holdinguser.FirstName;
        this.aUser.LastName = this.holdinguser.LastName;
        this.aUser.EmailAddress = this.holdinguser.EmailAddress;
        this.aUser.UserName = this.holdinguser.UserName;
        this.aUser.MobileNumber = this.holdinguser.MobileNumber;
        this.aUser.PhoneNumber = this.holdinguser.PhoneNumber;
        this.aUser.Iso2mobile = this.defaultCountry;
        this.aUser.Iso2phone = this.defaultCountryPhone;

        this.aUser.role = this.holdinguser.role;
        this.aUser.roleId = this.holdinguser.roleId;
    
        this.aUser.DialCodeMobile = this.holdinguser.DialCodeMobile;
       // this.aUser.MobileNumber = this.holdinguser.MobileNumber.number;
      this.aUser.DialCodePhone = this.holdinguser.DialCodePhone;
        //this.aUser.PhoneNumber = this.holdinguser.PhoneNumber.number;
        this.aUser.CommunicationType = this.holdinguser.CommunicationType;
    
        this.aUser.DateUpdated = new Date();
         
        this.authWebService.webrequest('POST','UserService', 'AmmendUser',  JSON.stringify(this.aUser)).then((ur) => {
          // this.toastr.options.onCloseClick = function() {  };
          document.getElementById('closeButton').click();
          this.toastService.success('Your profile has been updated successfully','User Update');
          // let t = this.toastr.success('Your profile has been updated successfully','User Update');
          // t.onHidden.subscribe(x => {
          //  this.router.navigate(['/home']);
          // })
          
			}, (error) => {
				this.toastService.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Failed to save user');
			});
      }
      else
      {
        this.toastService.error(ur.message,'Failed to Verify OTP')
      }
		
		}, (error) => {
			this.toastService.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za', 'Failed to Verify OTP' );
		});

		
		
	}

  close(){
    this.AttemptCount = 0;
    document.getElementById('Attempts').innerHTML = "You have 3 attempts left."
		document.getElementById('SaveButton').removeAttribute('disabled');
	}

  ckeckTerms(event){
    if (event.target.checked ) {
     this.terms = 'clicked';
    }
  }

  cancelupdate(){
   
    if((this.aUser.MobileNumber == null || this.aUser.EmailAddress == null)){
 
     this.authWebService.logout();
 
    }else{
 
     this.router.navigate(['/home']);
 
    }
 
   }
 
  checked(){
    console.log("checked",this.selectedRole);
  }
  

}

